export default __webpack_public_path__ + "static/media/sale__package__4cl.632d3c6d.png";